import ProductsAlgolia from './ProductsAlgolia.vue'

export default ProductsAlgolia
